export const page13 = {
  "name": "page13",
  "title": "Before Your Results",
  "elements": [
    {
      "type": "rating",
      "name": "contact_method",
      "title": "Your personalized results are ready! But first, our experts would like to know how they can reach you to offer additional health measurements tailored to your needs.",
      "isRequired": true,
      "autoGenerate": false,
      "rateCount": 2,
      "rateValues": [
        {
          "value": 1,
          "text": "E-mail"
        },
        {
          "value": 2,
          "text": "Phone"
        }
      ],
      "rateMax": 2
    },
    {
      "type": "text",
      "name": "email",
      "visibleIf": "{contact_method} = 1",
      "title": "Please leave your email",
      "isRequired": true,
      "inputType": "email"
    },
    {
      "type": "text",
      "name": "phone",
      "visibleIf": "{contact_method} = 2",
      "title": "Please leave your phone number",
      "isRequired": true,
      "inputType": "tel"
    }
  ]
};